<nb-layout windowMode>
	<nb-layout-header fixed *ngIf="user">
		<ngx-header></ngx-header>
	</nb-layout-header>

	<nb-sidebar
		class="menu-sidebar sidebar_class"
		tag="menu-sidebar"
		responsive
		*ngIf="user"
	>
		<ng-content select="nb-menu"></ng-content>
		<div class="user-container">
			<nb-user
				[nbContextMenu]="userMenu"
				[name]="(user?.username || user?.email)"
				[picture]="user?.imageUrl"
			></nb-user>
		</div>
	</nb-sidebar>

	<nb-layout-column *ngIf="!loading">
		<ng-content select="router-outlet"></ng-content>
	</nb-layout-column>

	<nb-layout-footer fixed>
		<ngx-footer></ngx-footer>
	</nb-layout-footer>

	<nb-sidebar
		*ngFor="let sidebar of (navigationBuilderService.sidebars$ | async)"
		[class]="sidebar.class"
		[tag]="sidebar.id"
		state="collapsed"
		fixed
		[end]="true"
	>
		<ngx-theme-sidebar [config]="sidebar"></ngx-theme-sidebar>
	</nb-sidebar>
</nb-layout>
